import React, { useState, useEffect } from "react";

import { isMobile } from "react-device-detect";

import { Link, useParams } from "react-router-dom";

import Carousel from "react-multi-carousel";

import "react-multi-carousel/lib/styles.css";

const Footer = () => {

  const { id } = useParams();

  const [menu, setMenu] = useState(false);

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2,
    },
  };

  return (
    <>

      <div className="col-12 d-grid float d-lg-none px-3">
        <div className="card py-3 px-3 shadow-lg rounded-pill bg-purple4">
          {menu ?
            <div className="">
              <Carousel
                swipeable={true}
                draggable={true}
                showDots={false}
                responsive={responsive}
                ssr={true} // means to render carousel on server-side.
                infinite={true}
                autoPlay={isMobile ? false : false}
                autoPlaySpeed={1000}
                keyBoardControl={true}
                transitionDuration={200}
                containerClass="carousel-container"
                removeArrowOnDeviceType={["tablet", "mobile"]}
                dotListClass="custom-dot-list-style"
                itemClass="carousel-item-padding-40-px"
                className="rounded-pill"
              >
                <Link to={"../" + id + "/home"} class="col-12 btn btn-white fs-3 text-purple btn-lg fw-medium rounded-pill"
                  onClick={() => setMenu(false)}
                >
                  <i class="bi bi-house-door"></i> Dashboard
                </Link>

                <Link to={"../" + id + "/lecture"} class="col-10 btn btn-white fs-3 text-purple btn-lg fw-medium rounded-pill"
                  onClick={() => setMenu(false)}
                >
                  <i class="bi bi-journal-bookmark-fill"></i> Lecture
                </Link>

                <Link to={"../" + id + "/work"} class="col-12 btn btn-white fs-3 text-purple btn-lg fw-medium rounded-pill"
                  onClick={() => setMenu(false)}
                >
                  <i class="bi bi-person-workspace"></i> Exercise
                </Link>

                <Link to={"../" + id + "/result"} class="col-10 btn btn-white fs-3 text-purple btn-lg fw-medium rounded-pill"
                  onClick={() => setMenu(false)}
                >
                  <i class="bi bi-graph-down-arrow"></i> Result
                </Link>

                <Link to={"../" + id + "/games"} class="col-12 btn btn-white fs-3 text-purple btn-lg fw-medium rounded-pill"
                  onClick={() => setMenu(false)}
                >
                  <i class="bi bi-controller"></i> Games
                </Link>

                <Link to={"../" + id + "/settings"} class="col-10 btn btn-white fs-3 text-purple btn-lg fw-medium rounded-pill"
                  onClick={() => setMenu(false)}
                >
                  <i class="bi bi-sliders"></i> Settings
                </Link>
              </Carousel>
            </div>
            :
            <div className="row">
              <div class="col-6 ms-3 btn btn-white fs-3 text-purple btn-lg shadow-lg rounded-pill"
                onClick={() => setMenu(true)}
              >
                <i class="bi bi-grid-1x2-fill"></i> Menu
              </div>

              <div class="col-2 ms-3 btn btn-white fs-3 text-purple btn-lg shadow-lg rounded-circle"
              >
                <i class="bi bi-controller"></i>
              </div>

              <Link to={"../" + id + "/logout"} class="col-2 ms-3 btn btn-white fs-3 text-purple btn-lg shadow-lg rounded-circle"
              >
                <i class="bi bi-power"></i>
              </Link>
            </div>
          }
        </div>
      </div>

      <div className="mt-18">
        <div className="row">
          <div className="col-4 col-lg-8">
            <span className="text-dark fs-4">Version 4.5.0</span>
          </div>

          <div className="col-8 col-lg-4 text-center">
            <img
              src="../assets/smlogo.png"
              alt=""
              class="img-fluid mb-2"
              width={isMobile ? "30%" : "30%"}
            />

            <span className="fs-4 text-purple3 ms-2">
              All rights reserved
            </span>
          </div>
        </div>

      </div>
    </>
  );
};

export default Footer;
